// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
let url = 'http://127.0.0.1:8000/';
url = 'https://bkhotelvillazon.merkancia360.com/public/';
url = 'https://bkvillazon.centervillazon.com/public/';
export const environment = {
  env: 'DEFAULT',
  production: false,
  serverBaseUrl: url + 'api',
  serverUrl: url + 'api',
  imgUrl: url + ''
};
// serverBaseUrl: 'https://fixturebol.com/bkalojamiento/public/api',
//   serverUrl: 'https://fixturebol.com/bkalojamiento/public/api',
//   imgUrl: 'https://fixturebol.com/bkalojamiento/public/'
/*
 * In development mode, for easier debugging, you can ignore zone related error
 * stack frames such as `zone.run`/`zoneDelegate.invokeTask` by importing the
 * below file. Don't forget to comment it out in production mode
 * because it will have a performance impact when errors are thrown
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
